<template>
  <card class="card-user" :class="'bg-card-'+theme">
    <div slot="image">
      <img width="360" height="200" src="static/img/full-screen-image-2.jpg" alt="...">
    </div>
    <div>
      <div class="author">
        <a href="https://pt.gravatar.com/" target="blank">
          <img class="avatar border-gray" v-bind:src="gravatar" alt="...">
        </a>
        <h4 class="title">
          {{ $auth.user().name + " " + $auth.user().surname }}
          <br>
          <a href="#">
            <small>{{ $auth.user().email }}</small>
          </a>
        </h4>
      </div>
      <p class="text-center">
        <small>Aluno de Opções Binárias</small>
      </p>
    </div>
    <hr>
    <div class="text-center">
      <div>Top Trader - Academia de Investimentos</div>
    </div>
  </card>
</template>
<script>
import md5 from "js-md5";

export default {
  data() {
    return {
      gravatar:
        "https://www.gravatar.com/avatar/" + md5(this.$auth.user().email)
    };
  },
  computed: {
    theme() {
      return this.$auth.user().layout;
    }
  }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/UserProfile/UserCard.vue